// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ModalRes.module.css */

.ModalRes_modalOverlay__UUoDl {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ModalRes_modal__n1tWd {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  position: relative;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  animation: ModalRes_fadeIn__z1RzC 0.3s ease-in-out;
}

.ModalRes_modalContent__WeyqO {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 2rem; */
  background: #fff;
  border-radius: 12px;
}

.ModalRes_modalContentWrap__Eyhrt {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  max-width: 320px;
}

.ModalRes_modalContentIc__mhN\\+C {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffc6c6;
  font-size: 40px;
  color: #ff6161;
}

.ModalRes_modalMessage__Qk9Bt {
  font-size: 17px;
  color: #333;
  font-weight: 500;
  margin: 0;
}

.ModalRes_modalActions__8bsuX {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 2rem;
}

.ModalRes_modalButton__-q8hY {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease-in-out;
  min-width: 100px;
}

.ModalRes_cancelBtn__U9OIt {
  background-color: #f1f1f1;
  color: #333;
}

.ModalRes_cancelBtn__U9OIt:hover {
  background-color: #e0e0e0;
}

.ModalRes_okBtn__8I6Ob {
  background-color: #007bff;
  color: white;
}

.ModalRes_okBtn__8I6Ob:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/Component/ModalRes.module.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kDAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ModalRes.module.css */\n\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #fff;\n  padding: 24px;\n  border-radius: 8px;\n  position: relative;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.modalContent {\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* padding: 2rem; */\n  background: #fff;\n  border-radius: 12px;\n}\n\n.modalContentWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 16px;\n  text-align: center;\n  max-width: 320px;\n}\n\n.modalContentIc {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffc6c6;\n  font-size: 40px;\n  color: #ff6161;\n}\n\n.modalMessage {\n  font-size: 17px;\n  color: #333;\n  font-weight: 500;\n  margin: 0;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 2rem;\n}\n\n.modalButton {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.2s ease-in-out;\n  min-width: 100px;\n}\n\n.cancelBtn {\n  background-color: #f1f1f1;\n  color: #333;\n}\n\n.cancelBtn:hover {\n  background-color: #e0e0e0;\n}\n\n.okBtn {\n  background-color: #007bff;\n  color: white;\n}\n\n.okBtn:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `ModalRes_modalOverlay__UUoDl`,
	"modal": `ModalRes_modal__n1tWd`,
	"fadeIn": `ModalRes_fadeIn__z1RzC`,
	"modalContent": `ModalRes_modalContent__WeyqO`,
	"modalContentWrap": `ModalRes_modalContentWrap__Eyhrt`,
	"modalContentIc": `ModalRes_modalContentIc__mhN+C`,
	"modalMessage": `ModalRes_modalMessage__Qk9Bt`,
	"modalActions": `ModalRes_modalActions__8bsuX`,
	"modalButton": `ModalRes_modalButton__-q8hY`,
	"cancelBtn": `ModalRes_cancelBtn__U9OIt`,
	"okBtn": `ModalRes_okBtn__8I6Ob`
};
export default ___CSS_LOADER_EXPORT___;
